import React, { useState, useEffect, useRef } from 'react';
import DOMPurify from 'dompurify';
import hljs from '../../utilities/highlightSetup';

import './HTMLViewer.css'

const HTMLViewer = ({ html, onImageClick }) => {
  const [sanitizedHTML, setSanitizedHTML] = useState('');
  const containerRef = useRef(null);

  useEffect(() => {
    const sanitized = DOMPurify.sanitize(html);
    setSanitizedHTML(sanitized);
  }, [html]);

  useEffect(() => {
    if (!containerRef.current) return;
    containerRef.current.querySelectorAll('pre.ql-syntax').forEach((block) => {
      hljs.highlightElement(block);
    });
  }, [sanitizedHTML]);

  const handleImageClick = (e) => {
    const imageSrc = e.target.getAttribute('src');
    if (onImageClick) {
      onImageClick(imageSrc);
    }
  };

  return (
    <div
      ref={containerRef}
      className="html-viewer"
      onClick={handleImageClick}
      dangerouslySetInnerHTML={{ __html: sanitizedHTML }}
    />
  );
};

export default HTMLViewer;
